import React from 'react';

import AgentFilters from './components/AgentFilters';
import AgentTable from './components/AgentTable';

import scss from './AgentList.module.scss';

function AgentList() {
  return (
    <div className={scss.pageWrapper}>
      <AgentFilters />

      <AgentTable />
    </div>
  );
}

export default AgentList;
